export interface DesktopThreadActivity<EnvironmentId extends string> {
  readonly environmentId: EnvironmentId;
  readonly session: {
    readonly status: string;
    readonly activeTurnId: unknown | null;
  } | null;
  readonly backgroundLiveness?: "working" | "monitoring" | null | undefined;
}

function hasActiveWork<EnvironmentId extends string>(
  thread: DesktopThreadActivity<EnvironmentId>,
): boolean {
  if (thread.backgroundLiveness === "working" || thread.backgroundLiveness === "monitoring") {
    return true;
  }

  return (
    thread.session?.status === "starting" ||
    (thread.session?.status === "running" && thread.session.activeTurnId !== null)
  );
}

export function shouldPreventDesktopSleep<EnvironmentId extends string>({
  enabled,
  localEnvironmentIds,
  threads,
}: {
  readonly enabled: boolean;
  readonly localEnvironmentIds: ReadonlySet<EnvironmentId>;
  readonly threads: ReadonlyArray<DesktopThreadActivity<EnvironmentId>>;
}): boolean {
  return (
    enabled &&
    threads.some((thread) => localEnvironmentIds.has(thread.environmentId) && hasActiveWork(thread))
  );
}
